import { readStructuralThemeBuildSlug, hasStructuralThemeFolder } from './structuralThemeFolder'

const themeCssLoaders = import.meta.glob('./*/theme.css')

// Build gate: env non-empty and != default. Only the slug in VITE_ACTIVE_THEME is loaded
// even if several theme folders (horizon, futures, …) exist on disk.
const activeSlug = readStructuralThemeBuildSlug()
if (activeSlug !== undefined && hasStructuralThemeFolder(activeSlug)) {
  const loader = themeCssLoaders[`./${activeSlug}/theme.css`]
  if (loader !== undefined) {
    void loader()
  }
}
